module.exports = __webpack_public_path__ + "img/calendar-outline-blue.def6d2ec.svg";